export default __webpack_public_path__ + "static/media/fauna-login.ec775427.png";